import { render, staticRenderFns } from "./ParameterSetting.vue?vue&type=template&id=a1a8240e"
import script from "./ParameterSetting.vue?vue&type=script&lang=js"
export * from "./ParameterSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports